import { cn } from '@costar-ui/cosmos';
import React from 'react';
export const IconPrivate = React.forwardRef(function IconPrivate(props, ref) {
  const {
    className,
    attr,
    color = 'currentColor',
    title,
    size = '1.5em',
    children,
    ...rest
  } = props;
  return React.createElement("svg", {
    ref: ref,
    ...attr,
    className: cn('csg-tw-icon-svg shrink-0', className),
    fill: color,
    height: size,
    width: size,
    ...rest
  }, title ? React.createElement("title", null, title) : null, children);
});
function Tree2Element(tree) {
  return tree && tree.map((node, i) => {
    const tag = node.tag || 'div';
    return React.createElement(tag, {
      key: i,
      ...node.attr
    }, Tree2Element(node.child));
  });
}
export function GenIcon(data) {
  return function Icon(props) {
    const {
      attr
    } = data ?? {};
    return React.createElement(IconPrivate, {
      attr: attr,
      ...props
    }, Tree2Element(data.child));
  };
}